import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import GifteeFlowHeader from "../components/GifteeFlowHeader.jsx";
import { useGiftees } from "../hooks/useGiftees";
import swipeStyles from "../styles/GifteeSwipeRecommendations.module.css";
import styles from "../styles/GifteeRecoLoading.module.css";

/** Stub delay before hub (replace with Firebase / Amazon pipeline). */
const LOADING_MS = 1000;

export default function GifteeRecoLoadingScreen() {
  const { gifteeId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { giftees, loading: gifteesLoading } = useGiftees();

  useEffect(() => {
    if (!gifteeId) return undefined;
    const id = window.setTimeout(() => {
      navigate(`/giftee/${gifteeId}`, { replace: true });
    }, LOADING_MS);
    return () => window.clearTimeout(id);
  }, [gifteeId, navigate]);

  const reminderTitle = location.state?.reminderTitle;
  const giftee = giftees.find((g) => g.id === gifteeId);
  const headerTitle = (giftee?.name || "").trim() || "Giftee";

  if (gifteesLoading) {
    return (
      <div className={swipeStyles.container}>
        <GifteeFlowHeader title={headerTitle} />
        <p className={swipeStyles.loading}>Loading...</p>
      </div>
    );
  }

  if (!giftee) {
    return (
      <div className={swipeStyles.container}>
        <GifteeFlowHeader title={headerTitle} />
        <p className={swipeStyles.notFound}>Giftee not found.</p>
      </div>
    );
  }

  const occasion =
    (reminderTitle && reminderTitle.trim()) || "Gift";

  return (
    <div className={swipeStyles.container}>
      <GifteeFlowHeader title={headerTitle} />

      <div className={swipeStyles.screen}>
        <h2 className={swipeStyles.occasionTitle}>{occasion}</h2>

        <div className={styles.loadingStackWrap}>
          <article className={styles.loadingCard} aria-busy="true" aria-live="polite">
            <div className={styles.hero}>
              <div className={styles.heroInner}>
                <img
                  src="/images/GiftGaff_Logo.svg"
                  alt=""
                  className={styles.heroLogo}
                  decoding="async"
                />
              </div>
            </div>

            <div className={styles.copyColumn}>
              <p className={styles.loadingHeadline}>Hang tight...</p>
              <p className={styles.loadingSubline}>Finding the perfect Gift ideas</p>
            </div>
          </article>
        </div>
      </div>
    </div>
  );
}
